import Collection from './collection.js';
import Payroll from 'newModels/payroll.js';

export default class Payrolls extends Collection {
    url() {
        if (this.company) {
            return this.company.url() + '/payrolls';
        }

        return '/Payrolls';
    }

    initialize(models, {company = null}) {
        this.model = Payroll;
        this.company = company;
        super.initialize(...arguments);
        if (!this.options.sortKey) {
            this.options.sortKey = 'createdAt';
        }
        if (!this.options.sortOrder) {
            this.options.sortOrder = 'descending';
        }
        return this;
    }

    getSavedCount() {
        return this.reduce((memo, model) => {
            return memo + ((model.get('status') < 3) ? 1 : 0);
        }, 0);
    }

    getSubmittedCount() {
        return this.reduce((memo, model) => {
            return memo + ((
                model.get('status') >= 3 &&
                model.get('status') < 9
            ) ? 1 : 0);
        }, 0);
    }

    getCompletedCount() {
        return this.reduce((memo, model) => {
            return memo + ((model.get('status') === 9) ? 1 : 0);
        }, 0);
    }
}



// WEBPACK FOOTER //
// ./app/new-collections/payrolls.js